import { gql } from "@apollo/client";
import { MESSAGE_INFO } from "../fragments";

export const SEND_MESSAGE = gql`
  mutation sendMessage($input: MessageInput!) {
    sendMessage(input: $input) {
      ...messageInfo
    }
  }
  ${MESSAGE_INFO}
`;

export const BLOCK_MEMBER = gql`
  mutation blockMember($memberId: ID!, $isBlocked: Boolean!) {
    blockMember(memberId: $memberId, isBlocked: $isBlocked) {
      id
      isBlocked
    }
  }
`;

export const READ_MESSAGE = gql`
  mutation readMessages($member: ID!) {
    readMessages(member: $member) {
      modifiedCount
    }
  }
`;

export const CREATE_MESSAGE_NOTIFICATION = gql`
  mutation createChatNotification($input: ChatNotificationInput!) {
    createChatNotification(input: $input) {
      id
      isRead
      branch {
        id
        name
      }
    }
  }
`;

export const EDIT_MESSAGE = gql`
  mutation editMessage($id: ID!, $message: String!) {
    editMessage(id: $id, message: $message) {
      ...messageInfo
    }
  }
  ${MESSAGE_INFO}
`;

export const DELETE_MESSAGE = gql`
  mutation deleteMessage($id: ID!) {
    deleteMessage(id: $id) {
      ...messageInfo
    }
  }
  ${MESSAGE_INFO}
`;
